<template>
  <div>
    <div class="container box">
      <div class="">
        <section class="">
          <div class="">
            <h1 class="is-size-4 mt-3 mb-5">Self Registered Users</h1>

            <div style="max-width: 200px">
              <div
                class="notification"
                style="background-color: hsl(206, 70%, 96%);"
              >
                <div class="has-text-centered">
                  <div>
                    <p class="heading">Registered Users</p>
                    <p class="title">{{ noOfUsers }}</p>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <!----
            <div class="field is-grouped is-pulled-right mb-4">
              <p class="control">
                <b-button
                  size="is-small"
                  type="is-primary"
                  icon-left="download"
                >
                  Download User List
                </b-button>
              </p>
            </div>

          -->

            <b-table
              :loading="isLoading"
              :narrowed="true"
              :debounce-search="1000"
              :mobile-cards="true"
              :paginated="paginated"
              :per-page="perPage"
              :striped="false"
              :hoverable="true"
              default-sort="reg_started"
              :data="users"
            >
              <b-table-column v-slot="props">
                <span v-if="props.row.sf_contact_id">
                  <a @click="$nav.viewUserGo(props.row.sf_contact_id)">
                    <b-icon icon="file-find" size="is-small"></b-icon
                  ></a>
                </span>
              </b-table-column>

              <b-table-column
                label="First Name"
                field="first_name"
                sortable
                searchable
              >
                <template #searchable="props">
                  <b-input
                    v-model="props.filters[props.column.field]"
                    icon="magnify"
                  />
                </template>
                <template v-slot="props">
                  {{ props.row.first_name }}
                </template>
              </b-table-column>

              <b-table-column
                label="Last Name"
                field="last_name"
                sortable
                searchable
              >
                <template #searchable="props">
                  <b-input
                    v-model="props.filters[props.column.field]"
                    icon="magnify"
                  />
                </template>
                <template v-slot="props">
                  {{ props.row.last_name }}
                </template>
              </b-table-column>

              <b-table-column label="Email" field="email" searchable sortable>
                <template #searchable="props">
                  <b-input
                    v-model="props.filters[props.column.field]"
                    icon="magnify"
                  />
                </template>
                <template v-slot="props">
                  <a
                    v-if="props.row.sf_contact_id"
                    @click="$nav.viewUserGo(props.row.sf_contact_id)"
                    >{{ props.row.email }}</a
                  >

                  <span v-else>{{ props.row.email }}</span>
                </template>
              </b-table-column>

              <b-table-column
                label="Registration Status"
                field="is_registration_complete"
                sortable
                v-slot="props"
              >
                <span
                  class="tag"
                  :class="{
                    'is-success': props.row.is_registration_complete,
                    'is-warning': !props.row.is_registration_complete,
                  }"
                >
                  {{
                    props.row.is_registration_complete ? "Complete" : "Pending"
                  }}
                </span>
              </b-table-column>

              <b-table-column
                field="reg_started"
                label="Registration Started"
                sortable
                centered
                v-slot="props"
              >
                <span class="">
                  {{ registrationStarted(props.row) }}
                </span>
              </b-table-column>

              <b-table-column
                field="reg_completed"
                label="Registration Completed"
                sortable
                centered
                v-slot="props"
              >
                <span class="">
                  {{ registrationCompleted(props.row) }}
                </span>
              </b-table-column>

              <b-table-column
                label="IP Address"
                field="ip"
                sortable
                v-slot="props"
              >
                {{ props.row.ip }}
              </b-table-column>



              <section slot="empty" class="section">
                <div class="content has-text-grey has-text-centered">
                  <template v-if="isLoading">
                    <p>Fetching data...</p>
                  </template>
                  <template v-else>
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>No users found</p>
                  </template>
                </div>
              </section>
            </b-table>
          </div>
        </section>
      </div>
    </div>
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "SelfRegistrationLog",
  components: {},
  data() {
    return {
      users: [],
      policies: [],
      isLoading: false,
      paginated: true,
      perPage: 20,
    };
  },
  methods: {
    async getUsers() {
      this.isLoading = true;
      var body = { accountId: this.profile.account.id };
      this.$app
        .huddleLabsServerCall("profile/register/get-users", body)
        .then((result) => {
          if (!result.error) {
            this.users = result.data;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: "Couldn't fetch any users",
            type: "is-danger",
          });
        });

      return this.users;
    },
    registrationStarted(row) {
      if (moment(row.created_at).isValid())
        return moment(row.created_at).format("MM/DD/YYYY");
      else return "--";
    },
    registrationCompleted(row) {
      if (moment(row.email_verified_at).isValid())
        return moment(row.email_verified_at).format("MM/DD/YYYY");
      else return "--";
    },

    /*
    uploadModal() {
      var details = {
        parent: this,
        component: UserUploadModal,
        props: {
          profile: this.profile,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          "upload-success": () => {
            this.getUsers();
          },
        },
      };
      this.$buefy.modal.open(details);
    },
    */
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    profile() {
      return this.$globals.profile;
    },
    noOfUsers() {
      if (this.users.length > 0) return this.users.length;
      else return 0;
    },
  },
};
</script>

<style scoped></style>
